import { styled, TextField } from "@mui/material";

const identifier = "GoogleAutocompleteAddress";

export const classes = {
    initialRoot: `${identifier}-initialRoot`,
    filledRoot: `${identifier}-filledRoot`,
};

export const StyledTextField = styled(TextField)(({ theme }) => ({
    [`& .${classes.initialRoot}`]: {
        "& .MuiInputLabel-root:not(.Mui-focused):not(.Mui-error)": {
            color: theme.palette.mediumDarkGrey?.main,
        },
    },
    [`& .${classes.filledRoot}`]: {
        "& .MuiInputLabel-root:not(.Mui-focused):not(.Mui-error)": {
            color: theme.palette.softBlack?.main,
        },
    },
}));
